export const siteMeta = {
  name: '黑料地址',
  tagline: '最新入口 · 防走丢 · 永久链接',
  description:
    '这里提供黑料地址最新入口，防走丢永久链接，实时更新防屏蔽，确保你能稳定访问。收藏本页，随时获取新网址，不再担心找不到。我们持续维护，让你永远有路可走。',
  updatedAt: '2026-09-11 09:24',
  updatedLabel: '最后更新',
  shareUrl: 'https://hl-address.example.com/',
  primaryUrl: 'https://hl-address.example.com/entry/main',
  issueNote: '第 1286 号维护版本 · 入口地址已同步',
};

export const heroStats = [
  { id: 'hs-1', value: '1286', unit: '天', label: '连续稳定维护' },
  { id: 'hs-2', value: '48', unit: '次', label: '今日地址校验' },
  { id: 'hs-3', value: '99.6', unit: '%', label: '入口可用率' },
  { id: 'hs-4', value: '6', unit: '条', label: '在线可达线路' },
];

export const entranceCards = [
  {
    id: 'entry-main',
    name: '主入口',
    badge: '首选',
    role: 'primary' as const,
    url: 'https://hl-address.example.com/entry/main',
    displayUrl: 'hl-address.example.com/entry/main',
    latency: '18ms',
    statusText: '通畅',
    updated: '2 分钟前校验',
    description: '默认推荐线路，点开即达，桌面端与移动端都稳定，日常访问优先用它。',
    tags: ['直连', '无中转'],
  },
  {
    id: 'entry-backup',
    name: '备用入口',
    badge: '应急',
    role: 'secondary' as const,
    url: 'https://hl-address.example.com/entry/backup',
    displayUrl: 'hl-address.example.com/entry/backup',
    latency: '24ms',
    statusText: '通畅',
    updated: '5 分钟前校验',
    description: '主入口拥挤或短暂卡顿时切换过来，负载更轻，通常能立刻恢复访问。',
    tags: ['负载均衡', '秒切'],
  },
  {
    id: 'entry-permanent',
    name: '永久链接',
    badge: '建议收藏',
    role: 'accent' as const,
    url: 'https://hl-address.example.com/entry/permanent',
    displayUrl: 'hl-address.example.com/entry/permanent',
    latency: '31ms',
    statusText: '通畅',
    updated: '刚刚校验',
    description: '地址长期不更换，把它加进书签，下次直接从收藏夹进来，不用再搜索。',
    tags: ['不更换', '书签首选'],
  },
];

export const statusStats = [
  { id: 'st-1', label: '今日已完成校验', value: '48', unit: '次', hint: '每 30 分钟刷新一轮' },
  { id: 'st-2', label: '入口可用率', value: '99.6', unit: '%', hint: '近 30 天滚动统计' },
  { id: 'st-3', label: '平均响应', value: '26', unit: 'ms', hint: '全部线路加权值' },
  { id: 'st-4', label: '最近地址变更', value: '6', unit: '天前', hint: '变更后已全部同步' },
];

export const lineHealth = [
  { id: 'ln-1', name: '主入口线路', node: '直连节点', latency: '18ms', load: 46, state: '通畅' },
  { id: 'ln-2', name: '备用入口 A', node: '备份节点', latency: '24ms', load: 38, state: '通畅' },
  { id: 'ln-3', name: '备用入口 B', node: '海外节点', latency: '52ms', load: 71, state: '通畅' },
  { id: 'ln-4', name: '永久链接跳转', node: '跳转服务', latency: '31ms', load: 55, state: '通畅' },
];

export const tickerNotes = [
  '09:24 主入口完成第 48 轮可用性校验，响应 18ms',
  '09:02 备用入口 A 负载回落至 38%，适合高峰时段使用',
  '08:36 永久链接跳转服务升级完成，书签用户无感知',
  '08:10 海外节点线路抖动已恢复，延迟回到 52ms',
  '07:42 全站地址巡检完成，未发现失效入口',
];

export const guideSteps = [
  {
    id: 'gs-1',
    step: '01',
    title: '先把本页收进书签',
    description:
      '无论你现在是从哪里进来的，都建议先把本页加入浏览器书签。这样即使日后入口地址有变化，你也能从书签回到这里拿到新网址，不会走丢。',
    points: ['书签栏固定一个位置', '手机端加入主屏幕', '记住本站名称即可找回'],
    image:
      'https://readdy.ai/api/search-image?query=Stylized%20flat%20editorial%20illustration%20of%20a%20warm%20minimal%20desk%20scene%20with%20a%20laptop%20screen%20showing%20a%20single%20bookmark%20ribbon%2C%20terracotta%20cream%20and%20olive%20palette%2C%20soft%20paper%20grain%20texture%2C%20abstract%20geometric%20shapes%2C%20generous%20negative%20space%2C%20calm%20natural%20lighting%2C%20no%20text&width=640&height=460&seq=hlzl-step-01&orientation=landscape',
  },
  {
    id: 'gs-2',
    step: '02',
    title: '按顺序试入口，别乱点',
    description:
      '从上往下依次尝试是最稳的做法：先主入口，再备用入口，最后才用永久链接跳转。多数情况下第一条线路就能打开，不必反复刷新页面。',
    points: ['主入口优先级最高', '打不开再换备用入口', '避免同一时间连续刷新'],
    image:
      'https://readdy.ai/api/search-image?query=Stylized%20flat%20editorial%20illustration%20of%20three%20simple%20route%20arrows%20branching%20toward%20one%20solid%20terracotta%20node%20on%20a%20cream%20paper%20background%2C%20olive%20and%20clay%20accents%2C%20soft%20grain%20texture%2C%20abstract%20geometric%20magazine%20composition%2C%20quiet%20trustworthy%20mood%2C%20no%20text&width=640&height=460&seq=hlzl-step-02&orientation=landscape',
  },
  {
    id: 'gs-3',
    step: '03',
    title: '打不开就先等一下',
    description:
      '访问异常大多和本地网络、浏览器缓存有关，而不是地址失效。清一下缓存、换个网络或稍等几分钟再试，通常就能恢复正常，页面上的状态栏也会同步提示。',
    points: ['优先检查本地网络', '清理浏览器缓存', '隔几分钟再试一次'],
    image:
      'https://readdy.ai/api/search-image?query=Stylized%20flat%20editorial%20illustration%20of%20a%20hand%20holding%20a%20phone%20with%20a%20saved%20bookmark%20star%20icon%2C%20warm%20terracotta%20sand%20and%20olive%20palette%2C%20abstract%20geometric%20magazine%20artwork%2C%20soft%20paper%20grain%20texture%2C%20minimal%20composition%2C%20quiet%20natural%20light%2C%20no%20text&width=640&height=460&seq=hlzl-step-03&orientation=landscape',
  },
];

export const preventGuides = [
  {
    id: 'pg-feature',
    size: 'large' as const,
    tag: '维护说明',
    title: '为什么地址会变，而本页不会变',
    excerpt:
      '入口地址偶尔调整，是为了绕开屏蔽、保持稳定可达。变的只是那条链接，不变的是本页——它是所有新地址的统一发布处。所以你只需要记住这一页，其余交给我们来跟进。',
    meta: '约 4 分钟阅读',
    image:
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20magazine%20artwork%20of%20layered%20paper%20cards%20linked%20by%20thin%20route%20lines%2C%20warm%20terracotta%20cream%20and%20olive%20palette%2C%20abstract%20geometric%20composition%2C%20soft%20grain%20texture%2C%20calm%20trustworthy%20mood%2C%20generous%20negative%20space%2C%20no%20text&width=880&height=600&seq=hlzl-guide-feature&orientation=landscape',
  },
  {
    id: 'pg-1',
    size: 'small' as const,
    tag: '防走丢',
    title: '三个动作，让你永远找得到',
    excerpt: '书签、主屏幕图标、收藏夹分组，任选两个做，基本就不会再走丢。',
    meta: '2 分钟',
  },
  {
    id: 'pg-2',
    size: 'small' as const,
    tag: '防屏蔽',
    title: '遇到拦截提示该怎么处理',
    excerpt: '先确认是网络层拦截还是地址失效，再决定换线路还是等待同步。',
    meta: '3 分钟',
  },
  {
    id: 'pg-3',
    size: 'small' as const,
    tag: '访问习惯',
    title: '为什么不要一次开太多标签',
    excerpt: '并发访问容易触发限速，反而让所有线路看起来都打不开。',
    meta: '2 分钟',
  },
  {
    id: 'pg-4',
    size: 'small' as const,
    tag: '常见误区',
    title: '“换个浏览器就能进”是真的吗',
    excerpt: '多数时候和浏览器无关，先看状态栏比反复换工具更快。',
    meta: '2 分钟',
  },
];

export const trustReasons = [
  {
    id: 'tr-1',
    title: '地址变动会即时同步',
    description: '任何一条入口发生变化，都会先在本页更新，再对外提示，不会让你拿着旧地址空转。',
  },
  {
    id: 'tr-2',
    title: '多线路互为备份',
    description: '主入口、备用入口与跳转服务彼此独立，单一线路波动不会影响你拿到可用地址。',
  },
  {
    id: 'tr-3',
    title: '状态透明，不藏着掖着',
    description: '校验次数、响应延迟、负载情况都直接展示，访问顺不顺畅你自己就能判断。',
  },
];

export const trustStats = [
  { id: 'ts-1', value: '1286', label: '天连续维护' },
  { id: 'ts-2', value: '17.4万', label: '累计送达人次' },
  { id: 'ts-3', value: '99.6%', label: '入口可用率' },
];

export const faqList = [
  {
    id: 'faq-1',
    question: '黑料地址最新入口到底以哪个为准？',
    answer:
      '以本页展示的第一条主入口为准。若主入口临时响应缓慢，按顺序尝试下方的备用入口即可；永久链接地址长期不变，适合直接收藏。',
  },
  {
    id: 'faq-2',
    question: '怎样做才算是真正的防走丢？',
    answer:
      '把本页加入浏览器书签或手机主屏幕即可。只要你能回到这一页，就能拿到当前有效的最新入口，不需要记住任何一条会变化的链接。',
  },
  {
    id: 'faq-3',
    question: '地址多久更新一次？会不会突然失效？',
    answer:
      '我们每 30 分钟对全部线路做一轮校验，出现异常会立即处理并在状态区标注。地址只在必要的时候才调整，调整后本页会同步更新。',
  },
  {
    id: 'faq-4',
    question: '所有入口都打不开，是我这边的问题吗？',
    answer:
      '先检查本地网络、切换一次网络环境，并清理浏览器缓存后重试；若仍不行，请对照页面上的状态提示，或稍等几分钟等下一轮校验结果。',
  },
  {
    id: 'faq-5',
    question: '手机上访问有什么需要特别注意的？',
    answer:
      '建议使用系统自带浏览器并加入主屏幕，避免在多个浏览器之间来回切换。移动网络与宽带的线路表现不同，必要时可互相切换验证。',
  },
  {
    id: 'faq-6',
    question: '收藏本页之后就一劳永逸了吗？',
    answer:
      '基本是。地址的变动由我们跟进，你只需保留这一个入口页面。万一将来本页域名也有调整，我们会提前在状态区提示新的可达方式。',
  },
];

export const footerColumns = [
  {
    id: 'fc-1',
    title: '快速定位',
    links: [
      { label: '最新入口', href: '#entrances' },
      { label: '实时状态', href: '#status' },
      { label: '使用指南', href: '#guide' },
    ],
  },
  {
    id: 'fc-2',
    title: '防走丢',
    links: [
      { label: '防走丢手册', href: '#prevent' },
      { label: '收藏指南', href: '#bookmark' },
      { label: '常见问题', href: '#faq' },
    ],
  },
  {
    id: 'fc-3',
    title: '关于本站',
    links: [
      { label: '维护说明', href: '#status' },
      { label: '更新日志', href: '#status' },
      { label: '联系我们', href: '#faq' },
    ],
  },
];